<template>
	<div v-if="userIsOperator && featureEnabled('service-provider-checklist') && checklist?.fields?.items?.de?.length" justify="center">
		<Disclosure :title="$t('text.checklist')" :expanded="true" data-cy="checklistInfo" ref="SECTION_checklistInfo">
			<div v-if="checklist && checklist.fields && checklist.fields.items && checklist.fields.items.de" class="field left-border">
				<p v-if="component==='BusinessProfile'" class="helpText" v-html="$t('text.checklistBPHelp')"/>
				<p v-if="component==='ServiceDesigner'" class="helpText" v-html="$t('text.checklistSDHelp')"/>

				<div style="padding-bottom: 10px;">
					<div v-for="(item, index) of checklist.fields.items.de" :key="index">
						<div style="display: flex; align-items: center;">
							<v-checkbox hide-details v-model="item.checked" style="flex-grow: 0; margin: 0; height: 40px;" />
							<span class="checklist-item-label">{{ item.text[selectedLocale] }}</span>
						</div>
					</div>
				</div>
				<v-btn class="greenButton" theme="dark" elevation="0" :disabled="allCompleted" @click="markAllAsComplete()" data-cy="markAllAsComplete"><v-icon>mdi-check</v-icon>{{$t('text.markAllAsComplete')}}</v-btn>
			</div>
		</Disclosure>
	</div>
</template>

<script>
import Common from '@/mixins/Common.vue'
import Disclosure from '@/components/common/Disclosure.vue'
import { Checklist } from '@/models/checklist.ts'

export default {
  name: 'Checklist',
  components: { Disclosure },

  mixins: [Common],
  props: {
		serviceProvider: { 
			type: Object 
		},
		product: { 
			type: Object 
		},
		component: {
			required: true,
			type: String
		},
	},
	data() {
		return {
		checklist: {
			sys: {
				id: ''
			},
			fields: {
				items: { de: []}
			}
		},
	}},
	computed: {
		allCompleted() {
			const incompleteItem = this.checklist?.fields?.items?.de?.find(x => x.checked === false)
			incompleteItem ? this.$refs['SECTION_checklistInfo']?.open() : this.$refs['SECTION_checklistInfo']?.close()
			return incompleteItem ? false : true
		}
	},
	watch: {
		serviceProvider() {
			this.setChecklistDetails()
		},
		product() {
			this.setChecklistDetails()
		}
	},
	mounted() {
		this.setChecklistDetails()
	},
	methods: {
		cloneChecklistEntry(entry) {
			return JSON.parse(JSON.stringify(entry))
		},
		haveChecklist() {
			return checklist?.fields?.items?.de?.length ? true : false
		},
		markAllAsComplete() {
			for (let item of this.checklist.fields.items.de) {
				item.checked = true
			}
		},
		setChecklistDetails() {
			this.checklist = new Checklist()

			const selectedClient = JSON.parse(JSON.stringify(this.$store.state.selectedClient))
			const checklistFeature = selectedClient.fields.features.de.find(x => x.id === 'service-provider-checklist')

			if (checklistFeature?.status === 'enabled') {
				let clientAssignmentForSelectedClient
				
				if (this.serviceProvider) {
					clientAssignmentForSelectedClient = this.serviceProvider.fields?.clientAssignments?.de?.find(x => x.fields.client.de.sys.id === selectedClient.sys.id)
				} else if (this.product) {
					clientAssignmentForSelectedClient = this.product.fields?.clientAssignments?.de?.find(x => x.fields.client.de.sys.id === selectedClient.sys.id)
				}

				if (clientAssignmentForSelectedClient) {
					if (!clientAssignmentForSelectedClient.fields.checklist?.de || Object.keys(clientAssignmentForSelectedClient.fields.checklist).length === 0) {
						// MYS-3732: deep copy of client checklist to avoid overwriting it (copy by value vs copy by reference)
						this.checklist = this.cloneChecklistEntry(selectedClient?.fields?.serviceProviderChecklist?.de)
						if (!this.checklist.sys) this.checklist.sys = {}
						this.checklist.sys.id = ''

						if (this.checklist?.fields?.items?.de?.length) {
							for (const item of this.checklist.fields.items.de) {
								item.checked = false
							}
						}

					} else {
						let caChecklist = this.cloneChecklistEntry(clientAssignmentForSelectedClient.fields.checklist.de)
						if (!this.checklist.sys) this.checklist.sys = {}
						this.checklist.sys.id = caChecklist.sys.id
						this.checklist.fields.items.de = []

						//Merge client checklist in case items have been added / removed since last update
						if (selectedClient?.fields?.serviceProviderChecklist?.de?.fields?.items?.de?.length) {
							for (const checklistItem of selectedClient.fields.serviceProviderChecklist.de.fields.items.de) {
								const item = caChecklist?.fields?.items?.de.find(x => x.key === checklistItem.key && x.text.de === checklistItem.text.de)
								//Add new checklist item
								if (!item) {
									this.checklist.fields.items.de.push(this.cloneChecklistEntry(checklistItem))
								} else {
									//Add existing ca checklist items that have not been removed from the client checklist
									this.checklist.fields.items.de.push(this.cloneChecklistEntry(item))
								}
							}
						}
					}
				}
			}
			this.$forceUpdate()
		}
	}
}
</script>

<style scoped>
.checklist-item-label { padding-top: 12px; font-size: 14pt !important; }
.line { padding: 10px; border-bottom: 1px solid #ccc; }
.line:last-child { border: none; }
</style>